import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import Logger from '../../lib/analytics/logger';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import NavigationConstants from '../../components/LobbyOverlay/NavigationConstants';
/** @typedef {import('shared/api/Constants').LobbyItemsInfo} LobbyItemsInfo */

/** @typedef {import('shared/api/Constants').LivePanelInfo} LivePanelInfo */

export var PAGE_SIZE = 8;

var Home = /*#__PURE__*/function (_Component) {
  _inherits(Home, _Component);

  var _super = _createSuper(Home);

  function Home(props) {
    _classCallCheck(this, Home);

    return _super.call(this, props);
  }

  _createClass(Home, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      Logger.sendEvent(EVENT_TYPES.GAME_ROOM_LOADED, {
        name: 'slotGames'
      });
      this.props.setNavState(NavigationConstants.NO_HIDE);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var slotGames = this.props.slotGames;
      var panelList = [];
      var numColumn = 1;
      var pagedGames = [];
      var pageNumber = 0;

      if (slotGames && slotGames.gameList && slotGames.gameList.length > 0) {
        panelList = slotGames.gameList[0].games || [];
        panelList = panelList.filter(function (game) {
          return !game.IS_HIDDEN;
        });
        pagedGames = new Array(Math.ceil(panelList.length / PAGE_SIZE)).fill().map(function (_currentPage, index) {
          return panelList.slice(index * PAGE_SIZE, (index + 1) * PAGE_SIZE);
        }) // Second map to change tile order based on levels
        .map(function (gamePage) {
          var oddIndexItems = [];
          var evenIndexItems = [];

          if (gamePage.length == PAGE_SIZE) {
            gamePage.forEach(function (game, index) {
              index % 2 == 0 ? evenIndexItems.push(game) : oddIndexItems.push(game);
            });
            return gamePage = evenIndexItems.concat(oddIndexItems);
          }

          return gamePage;
        });
        pagedGames.forEach(function (page, index) {
          if (page.find(function (game) {
            return game.UNLOCK_LEVEL <= _this.props.userLevel;
          })) {
            pageNumber = index;
          }
        });

        if (this.props.gameInfo.lastGameVisited != '') {
          pagedGames.forEach(function (page, index) {
            if (page.find(function (game) {
              return game.GAME_ID === _this.props.gameInfo.lastGameVisited;
            })) {
              pageNumber = index;
            }
          });
        }
      }

      var render = this.props.render;
      return render(_objectSpread({
        panelList: panelList,
        numColumn: numColumn,
        pagedGames: pagedGames,
        pageNumber: pageNumber
      }, this.props));
    }
  }]);

  return Home;
}(Component);

export { Home as default };